import React from 'react';
import { ReactElement } from 'react';
import { BsBan, BsCheckCircle, BsCircle, BsExclamationCircle, BsXCircle } from 'react-icons/bs';

import { Box } from '@qwealth/qcore';
import { TASK_NOT_STARTED, TASK_IN_PROGRESS, TASK_COMPLETED, TASK_BLOCKED, TASK_OVERDUE, TASK_DELETED } from '@qwealth/qdata';
import { ExtendedTaskStatus } from 'data/models/Activity';

interface Props {
  status: ExtendedTaskStatus;
  iconSize?: string;
}

const TaskStatusIcon: React.FC<Props> = ({ status, iconSize = '24px' }): ReactElement => {
  switch (status) {
    case TASK_NOT_STARTED:
      return (
        <Box color="gray.1">
          <BsCircle size={iconSize} />
        </Box>
      );
    case TASK_IN_PROGRESS:
      return (
        <Box color="blue">
          <img src="task-in-progress.svg" width={iconSize} height={iconSize} />
        </Box>
      );
    case TASK_BLOCKED:
      return (
        <Box color="yellow">
          <BsBan size={iconSize} />
        </Box>
      );
    case TASK_COMPLETED:
      return (
        <Box color="green">
          <BsCheckCircle size={iconSize} />
        </Box>
      );
    case TASK_OVERDUE:
      return (
        <Box color="red">
          <BsExclamationCircle size={iconSize} />
        </Box>
      );
    case TASK_DELETED:
      return (
        <Box color="gray.2">
          <BsXCircle size={iconSize} />
        </Box>
      );
    default:
      return (
        <Box color="gray.1">
          <BsCircle size={iconSize} />
        </Box>
      );
  }
};

export default TaskStatusIcon;
